import React, { useEffect, useState } from 'react';

export const GUIDE_REGISTRY = {
  monitor: {
    id: 'monitor',
    body:
      'The monitor scans every GL cell for the month and scores surprises: how far the value sits from its own history (z), how many dollars are at stake (log$), and how much the category matters (weight). Your job is to disposition the queue — Real, Noise, or Known recurring. Each verdict teaches the system: rules suppress repeat noise, and narratives cite your judgments next close.',
    readsFrom: 'GL_Transaction · ci_finding · ci_suppression_rule',
  },
  memory: {
    id: 'memory',
    body:
      'Everything the system has learned from analysts: active suppression rules drafted from your dispositions, and the verdict history that produced them. Deactivate a rule if it starts hiding real signal.',
    readsFrom: 'ci_suppression_rule · ci_disposition',
  },
  expectations: {
    id: 'expectations',
    body:
      'Forecast context has three parts. Company guardrails are the editable, board-cited bands the narrator checks every close — breaches surface in board narratives. Unit forecast baselines are read-only: the expectation for a business equals the latest governed forecast value for the selected period, so there is no second source of truth to hand-maintain. Overrides are the only editable departure from that baseline and require a note and actor so every change is audited.',
    readsFrom: 'expectations_company · GL_Fact forecast versions · forecast_context_override',
  },
  close: {
    id: 'close',
    body:
      "A close run computes deterministic variance bridges for every line, then narrates them scope by scope under a numbers guard — every figure in a narrative must match the deterministic layer. Review each run's narratives and guard status here before presenting the board pack.",
    readsFrom: 'ci_close_run · ci_bridge_component · ci_narrative',
  },
  board: {
    id: 'board',
    body:
      "The earnings review pack, one screen per section. Matrices compare Actual to your chosen basis; every waterfall is the deterministic decomposition of one line's variance; the right rail pairs each section's narrative with the monitor evidence behind it — signal vs noise. Evidence rows expand to the analyst judgments they cite.",
    readsFrom: 'ci_narrative · ci_bridge_component · ci_finding',
  },
};

export const getGuideByTabId = (tabId) => GUIDE_REGISTRY[tabId] || null;

const storageKey = (id) => `ci-guide-${id}`;

export default function SectionGuide({ guideId }) {
  const guide = getGuideByTabId(guideId);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!guide) return;
    try {
      if (localStorage.getItem(storageKey(guide.id)) === '1') setOpen(true);
    } catch {
      /* ignore */
    }
  }, [guide]);

  if (!guide) return null;

  const toggle = () => {
    const next = !open;
    setOpen(next);
    try {
      localStorage.setItem(storageKey(guide.id), next ? '1' : '0');
    } catch {
      /* ignore */
    }
  };

  return (
    <div className={`ci-section-guide${open ? ' ci-section-guide--open' : ''}`}>
      <button
        type="button"
        className="ci-section-guide-toggle ci-tip"
        data-tip={open ? 'Collapse section guide' : 'Expand section guide'}
        onClick={toggle}
        aria-expanded={open}
      >
        <span className="ci-section-guide-eyebrow">
          GUIDE <span aria-hidden>●</span> What am I looking at?
        </span>
        <span className="ci-section-guide-chevron" aria-hidden>
          {open ? '▾' : '▸'}
        </span>
      </button>
      {open && (
        <div className="ci-section-guide-body">
          <p>{guide.body}</p>
          {guide.readsFrom && (
            <p className="ci-section-guide-sources">READS FROM: {guide.readsFrom}</p>
          )}
        </div>
      )}
    </div>
  );
}
